/**
 * @fileoverview POST handler for "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints/:component".
 * Templated create — the body is just {period, times} for the targeted
 * component. The dashboard backend generates the underlying Conman
 * comparator/logic/applied_groups entries and POSTs to /guardrails/.
 * Conman 409s if a constraint already exists for the component; the caller
 * should retry as PUT in that case.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys } from "./constants";
import type {
  PostDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentProps,
  PostDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult,
} from "./types";

export const postDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentCacheKeys,
  ({
    appGroupId,
    dsaId,
    component,
    period,
    times,
  }: PostDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentProps): Promise<PostDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult> =>
    fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints/${component}`, "POST", {
      period,
      times,
    })
);
